// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isCompanyGenerativeAiOptOutResult = objectOf({
  generative_ai_kill_switch: boolean,
});
